export const routes = {
  order: '/order/:id',
  login: '/login',
  flows: '/flows',
  packaging: '/packaging',
  packingList: '/packing-list/:autoid',
  multiOrderSkids: '/multi-order-skids',
  deliveries: '/deliveries',
  machines: '/machines/:stage',
  settings: '/settings',
  scheduling: '/',
  passwordReset: '/password-reset',
  scanner: '/scanner/:detail',
  passwordResetConfirm: '/password-reset/:uid64/:token'
} as const

export const DEFAULT_LOGOUT_REDIRECT = routes.login
export const DEFAULT_LOGIN_REDIRECT = routes.scheduling
